// File upload configuration constants
// MAX_FILES_MAPPING_UPLOAD defines the maximum number of files that can be uploaded
// at once in the MultipleFilesMappingUpload component
export const MAX_FILES_MAPPING_UPLOAD = parseInt(process.env.MAX_FILES_MAPPING_UPLOAD || '2', 10); 